// Student dashboard route (inside BodyView layout)
export default [
  {
    path: '/student-dashboard',
    name: 'StudentDashboard',
    component: () => import("@/views/Page/Student/StudentDashboard.vue"),
    meta: {
      title: 'Student Dashboard',
      requiresStudentAuth: true,
    },
  },
];

